'use es6';

import objectFilter from './objectFilter';
/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to exclude
 */

const omit = (object, ...filters) => objectFilter(object, false, ...filters);

export default omit;